import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

interface LogoProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  withText?: boolean;
  linkTo?: string;
}

export default function Logo({ 
  className = '', 
  size = 'medium', 
  withText = true,
  linkTo = '/'
}: LogoProps) {
  const { theme } = useTheme();
  
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  const textSizeClasses = {
    small: 'text-lg',
    medium: 'text-xl',
    large: 'text-2xl'
  };
  
  const LogoComponent = (
    <div className={`flex items-center ${className}`}>
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden shadow-md border-2 border-gray-300 dark:border-gray-600 flex-shrink-0`}>
        <img 
          src={theme === 'dark' ? 'https://imgur.com/ixBl7oD.png' : 'https://imgur.com/U8Nsvff.png'} 
          alt="Aussi Clean Logo" 
          className="w-full h-full object-cover"
        />
      </div>
      {withText && (
        <span className={`ml-2 font-semibold text-gray-800 dark:text-gray-200 ${textSizeClasses[size]}`}>
          Aussi Clean
        </span>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center">
        {LogoComponent}
      </Link>
    );
  }

  return LogoComponent;
}